import { GiveawayQuestion } from '@/staff/domain/club/giveaway/GiveawayQuestion';
import { BackendGiveawayAnswer, toGiveawayAnswer } from '@/staff/secondary/club/giveaway/BackendGiveawayAnswer';
import { Optional } from '@/common/domain/Optional';
import { BackendTranslation, fromBackendTranslation } from '@/common/secondary/BackendTranslation';
import { GiveawayQuestionTitle } from '@/staff/domain/club/giveaway/GiveawayQuestionTitle';

export interface BackendGiveawayQuestion {
  id: string;
  title: string;
  preTitle?: string;
  answers: BackendGiveawayAnswer[];
  rightAnswer?: BackendGiveawayAnswer;
  required: boolean;
  quizMode: boolean;
  multiline: boolean;
  titleTranslations?: BackendTranslation[];
  preTitleTranslations?: BackendTranslation[];
}

export const toGiveawayQuestion = (backendGiveawayQuestion: BackendGiveawayQuestion): GiveawayQuestion => {
  const answers = backendGiveawayQuestion.answers.map(toGiveawayAnswer);

  return {
    id: backendGiveawayQuestion.id,
    title: backendGiveawayQuestion.title,
    answers,
    rightAnswer: Optional.ofUndefinable(answers.find(answer => answer.text === backendGiveawayQuestion.rightAnswer?.text)),
    required: backendGiveawayQuestion.required,
    quizMode: backendGiveawayQuestion.quizMode,
    multiline: backendGiveawayQuestion.multiline,
    preTitle: Optional.ofEmpty(backendGiveawayQuestion.preTitle),
    titleTranslations: backendGiveawayQuestion.titleTranslations?.map(fromBackendTranslation<GiveawayQuestionTitle>),
    preTitleTranslations: Optional.ofUndefinable(backendGiveawayQuestion.preTitleTranslations?.map(fromBackendTranslation<string>)),
  };
};
